module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(_vm.helpBody && _vm.focused) ? _c('ed-input-tooltip', {
    attrs: {
      "helpHeader": _vm.helpHeader,
      "helpBody": _vm.helpBody
    }
  }) : _vm._e(), (_vm.fieldLabel) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.fieldLabel)), (_vm.required) ? _c('span', [_vm._v(" *")]) : _vm._e()]) : _vm._e(), _c('textarea', _vm._b({
    directives: [{
      name: "focus",
      rawName: "v-focus.lazy",
      value: (_vm.autofocus),
      expression: "autofocus",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "autofocus": _vm.autofocus,
      "cols": _vm.cols,
      "required": _vm.required
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "focus": function($event) {
        _vm.focused = true
      },
      "blur": function($event) {
        _vm.focused = false
      },
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  }, 'textarea', _vm.$props, false))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e45cf9a2","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/edTextarea/index.vue
// module id = Dvoi
// module chunks = 13 14